<div [formGroup]="formGroup">
  <coreui-table
    class="scroll-table"
    #scrollTable
    coreUIInfiniteScroll
    (scrollLimitReached)="limitReached()"
    [scrollTarget]="'document'" 
    [triggerElementOffset]="700"
  >
    <thead coreUITableSort>
      <tr coreUITableHeaderRow>
        <th scope="col" class="table-header">
          <coreui-table-header-column [disableSort]="true">
            Delivery Name
          </coreui-table-header-column>
        </th>
        <th scope="col">
          <coreui-table-header-column [disableSort]="true">
            Last Run Date
          </coreui-table-header-column>
        </th>
        <th scope="col" class="table-header">
          <coreui-table-header-column [disableSort]="true">
            Audience Sent
          </coreui-table-header-column>
        </th>
        <th scope="col" class="table-header">
          <coreui-table-header-column [disableSort]="true">
            Delivered To
          </coreui-table-header-column>
        </th>
        <th scope="col" class="table-header">
          <coreui-table-header-column [disableSort]="true">
            Count
          </coreui-table-header-column>
        </th>
        <th scope="col" class="table-header" coreUITableActionColumn></th>
      </tr>
    </thead>
    <tbody formArrayName="rows">
      <tr
        *ngFor="let item of filteredFeedDataList; let i = index"
        coreUITableRow
      >
        <td>
          <div class="has-bottom-space">{{ item.data?.name }}</div>
        </td>
        <td>
          <div>
            {{
              item.data?.lastRunTime
                ? this.datePipe.transform(
                    item.data?.lastRunTime,
                    "M/d/YY h:mm a",
                    "UTC"
                  ) + " UTC"
                : "NA"
            }}
          </div>
        </td>
        <td class="nameCol">
          <div>
            <span>{{ item?.tags?.["CAB-Audience-Display-Name"] || 'NA' }}</span>
          </div>
        </td>
        <td>
          <div
            [class.has-bottom-space]="
              item.sendToTargetInfo?.connectionDisplayName
            "
          >
            {{ item?.data?.targetConnectorSummary?.displayName || "NA" }}
          </div>
        </td>
        <td>
          {{ item?.data?.lastRunAcceptedRecords || "NA" }}
        </td>
        <td coreUITableActionColumn>
          <button (click)="navigateTosendTo(item)" *ngIf="item.tags?.['CAB-Audience-Id']" type="button" coreUIButton="icon" tabindex="0" withBorder>
            <i scale="1.5" coreUIIcon="chevronRight"></i>
          </button>
        </td>
      </tr>
      <tr coreUITableRow *ngIf="isLoader">
        <td>
          <coreui-loading-table-column></coreui-loading-table-column>
        </td>
        <td>
          <coreui-loading-table-column></coreui-loading-table-column>
        </td>
        <td>
          <coreui-loading-table-column></coreui-loading-table-column>
        </td>
        <td>
          <coreui-loading-table-column></coreui-loading-table-column>
        </td>
        <td>
          <coreui-loading-table-column></coreui-loading-table-column>
        </td>
        <td>
          <coreui-loading-table-column></coreui-loading-table-column>
        </td>
      </tr>
    </tbody>
    <tr
      *ngIf="
        ((loadingService.isLoading$ | async) === null ||
          (loadingService.isLoading$ | async) === undefined ||
          (loadingService.isLoading$ | async) === false) &&
        !isLoader &&
        !filteredFeedDataList?.length
      "
      coreUITableRow
      [disableHover]="true"
    >
      <td colspan="8" class="empty-list">
        <coreui-graphic-message label="No Results Found" graphic="noResults">
          Sorry, we did not find any results for your search.
        </coreui-graphic-message>
      </td>
    </tr>
    <tr
      *ngIf="!filteredFeedDataList?.length && !loadingService.isLoading$"
      coreUITableRow
      [disableHover]="true"
    >
      <td colspan="8" class="empty-list">
        <coreui-graphic-message label="Nothing Here" graphic="empty">
          There are no saved definitions.
        </coreui-graphic-message>
      </td>
    </tr>
  </coreui-table>
</div>
